<template>
    <div class="level">


        <label for="level">Level</label>
        <input id="level" type="number" v-model="level">

        <label for="levelprogress">Progress</label>
        <input id="levelprogress" type="number" v-model="levelprogress">


        {{ levelList }}

    </div>
</template>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">



</style>

<script>

    export default {
        name: 'Level',
        data() {
            return {
                pbuildings: [{}, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}],
                level: 0,
                levelprogress: 0,
                levelList: {14:3750,
                    15:6000,
                    16:10000,
                    17:16000,
                    18:26000,
                    19:42000,
                    20:68000,
                    21:110000,
                    22:170000,
                    23:280000,
                    24:450000,
                    25:450000,
                    26:450000,
                    27:450000,
                    28:450000,
                    29:450000,
                    30:450000}
            };
        },
        computed: {


        },
        methods: {

        },
        components: {},
        beforeMount() {

            let me = this;

            this.level = parseInt(window.localStorage.getItem('level'));
            this.levelprogress = parseInt(window.localStorage.getItem('levelprogress'));

            if (JSON.parse(window.localStorage.getItem('pbuildings'))) {
                let buildings = JSON.parse(window.localStorage.getItem('pbuildings'));
                _.each(buildings, function(item, key) {

                    console.log(this);
                    me.$set(me.pbuildings[key], 'level', item.level);
                    me.$set(me.pbuildings[key], 'id', item.id);
                    me.$set(me.pbuildings[key], 'resource', item.resource);
                });

            }



        },
        watch: {
            level() {

                window.localStorage.setItem('level', this.level);

            },
            levelprogress() {
                window.localStorage.setItem('levelprogress', this.levelprogress);
            },
        },
    };
</script>
